module.exports = __webpack_public_path__ + "static/media/mollyplace.0f691c39.jpeg";